module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_17_B_2.865f8564.mp3";